import { Stack, Typography } from "@mui/material";
import { AccountDhBrandCard } from "./account-dh-brand-card";
import { AccountSlackAppsCard } from "./account-slack-apps-card";

import type { AdminAccountLimit } from "../../generic/server/supabase-account-service";
import type { FC } from "react";

export const AccountIntegrationsSection: FC<{ account: AdminAccountLimit }> = ({ account }) => (
  <Stack id="integrations" spacing={2}>
    <Typography variant="h6">Integrations</Typography>
    <AccountDhBrandCard accountId={account.id} accountName={account.name} />
    <AccountSlackAppsCard account={account} />
  </Stack>
);
